export default __webpack_public_path__ + "static/media/lock.cc38b3f9.svg";